export const isASC = process.env.GATSBY_REACT_I18N_NAMESPACE === 'asc'
export const isRSC = process.env.GATSBY_REACT_I18N_NAMESPACE === 'rsc'
export const isTSC = process.env.GATSBY_REACT_I18N_NAMESPACE === 'tsc'
export const isFSC = process.env.GATSBY_REACT_I18N_NAMESPACE === 'fsc'
export const isSSC = process.env.GATSBY_REACT_I18N_NAMESPACE === 'ssc'

export { isBrowser, getUrlParameter } from './url';
